export enum PageType {
  Search = 'search',
  Category = 'category',
  Partner = 'partner',
}

export type FilterNavType = 'sticky filter' | 'collapsed sidebar' | 'fixed sidebar';
